export enum AssetType {
  AURORA = 'aurora',
  DEVICE = 'device',
  RUUVI_TAG = 'ruuvi_tag',
  AXIOMA_W1 = 'axioma_w1'
}
